import "./preview-infographic.scss";
import { infographicTemplateConfig } from "../../../config/infographic.config";
import { ImagePosition } from "../../../model/image-position.enum";
import { TextType } from "../../../model/text-type.enum";

const PreviewInfographicComponent = ({
    refProp,
    width,
    height,
    scale,
    fontScale,
    selectedTemplate,
    selectedSize,
    textBoxes,
    imageBoxes,
    preview = false
}) => {
    const customClass: string = `${preview ? 'small-' : ''}preview-wrapper`;
    const template = infographicTemplateConfig[selectedTemplate][selectedSize];
    const keyNameDefault = preview ? 'preview' : 'real';

    const scaleFontSize = (htmlContent: string): string => {
        if (!htmlContent) return '';
        if (preview) return htmlContent;

        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, "text/html");

        const spans = doc.querySelectorAll<HTMLElement>('[style*="font-size"]');

        spans.forEach((span) => {
            const style = span.style.fontSize;
            if (style) {
                const currentSize = parseFloat(style);
                const unit = style.replace(currentSize.toString(), '').trim();
                const newSize = currentSize * fontScale;

                span.style.fontSize = `${newSize}${unit}`;
            }
        });

        return doc.body.innerHTML;
    }

    return (
        <div
            ref={refProp}
            className={`capture-area ${customClass}`}
            style={{
                width: width,
                height: height,
                background: '#FFF9FD',
            }}
        >
            {
                template.backgroundImage &&
                <img
                    src={template.backgroundImage}
                    style={{ width: width, height: height }}
                />
            }

            {
                textBoxes && textBoxes.map((box, index) => {
                    const templateText = template.textBox[index];
                    const isTopic = templateText.type === TextType.TOPIC;
                    const isQuote = templateText.type === TextType.QUOTE;
                    const isHeadlineCenter = box.id === 1 && selectedTemplate !== 3;

                    return (
                        <div
                            key={`${keyNameDefault}-text-${box.id}`}
                            className='ql-editor'
                            style={{
                                width: templateText.width * scale,
                                height: typeof templateText.height === 'string' ? templateText.height : templateText.height * scale,
                                color: templateText.fontColor,
                                fontSize: `${templateText.fontSize * scale}px`,
                                fontFamily: (isTopic || isQuote) ? 'LINESeedSansTH_Bd' : 'LINESeedSansTH_Rg',
                                textAlign: isHeadlineCenter ? 'center' : 'left',
                                position: 'absolute',
                                left: templateText.x * scale,
                                top: templateText.y * scale,
                                zIndex: 5,
                                overflow: 'hidden',
                            }}
                            dangerouslySetInnerHTML={{ __html: scaleFontSize(box.text) }}
                        ></div>
                    )
                })
            }

            {
                imageBoxes && imageBoxes.map((box, index) => {
                    const templateImage = template.imageBox?.[index];

                    return (
                        <div
                            key={`${keyNameDefault}-image-${box.id}`}
                            className="image-wrapper"
                            style={{
                                width: templateImage.width * scale,
                                height: typeof templateImage.height === 'string' ? templateImage.height : templateImage.height * scale,
                                position: 'absolute',
                                left: templateImage.x * scale,
                                top: templateImage.y * scale,
                                zIndex: templateImage.position === ImagePosition.FRONT ? 3 : 1,
                            }}
                        >
                            {
                                box.src && (
                                    <img
                                        src={box.src}
                                        width={templateImage.width * scale}
                                    />
                                )
                            }
                        </div>
                    );
                })
            }

            <div
                className="image-element-wrapper"
                style={{
                    width: width,
                    height: height,
                }}
            >
                {
                    template.elementImage &&
                    <img
                        src={template.elementImage}
                        style={{ width: width, height: height, position: 'absolute', top: 0, left: 0 }}
                    />
                }
            </div>
        </div>
    );
}

export default PreviewInfographicComponent;